// Author Lin
// Date 2021-11-15 11:50:39

class MintalMesPrdGenertorSetDowntime {
        constructor({
                id = null,
                recordTime = '',
                shiftId = '',
                generatorSetId = '',
                generatorCode = '',
                shutdownTime = '',
                restartTime = '',
                shutdownDuration = '',
                shutdownReason = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.recordTime = recordTime;
            this.shiftId = shiftId;
            this.generatorSetId = generatorSetId;
            this.generatorCode = generatorCode;
            this.shutdownTime = shutdownTime;
            this.restartTime = restartTime;
            this.shutdownDuration = shutdownDuration;
            this.shutdownReason = shutdownReason;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdGenertorSetDowntime();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftId',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.shiftId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'generatorSetId',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.generatorSetId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'generatorName',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.generatorName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shutdownTime',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.shutdownTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'restartTime',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.restartTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shutdownDuration',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.shutdownDuration',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shutdownReason',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.shutdownReason',
                sortable: true,
                form: {
                type: 'select'
                ,options: [
                        { value: '1', text: '机组本身原因' },
                                    { value: '2', text: '四台电炉停炉引起煤气量不足' },
                                    { value: '3', text: '限电' }
                    ]
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.reviewer',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            generatorSetIdFilter : '',
            generatorCodeFilter : '',
            shutdownTimeRteFilter : '',
            shutdownTimeLteFilter : '',
            restartTimeRteFilter : '',
            restartTimeLteFilter : '',
            shutdownDurationFilter : '',
            shutdownReasonFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'generatorCodeFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.generatorCode',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstGeneratorSet'
                    ,correspondingField: 'generatorCode'
                    ,fieldsBindingByEntityModalSelected: '{"generatorSetId":"id"}'
                        }
                },
                {
                key: 'shutdownTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.shutdownTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'shutdownTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.shutdownTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'restartTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.restartTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'restartTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.restartTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'shutdownReasonFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.shutdownReason',
                disabled: false,
                form: {
                type: 'select'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: '机组本身原因' },
                        { value: '2', text: '四台电炉停炉引起煤气量不足' },
                        { value: '3', text: '限电' }
                    ]
                }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                {
                key: 'reviewerFilter',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.filter.reviewer',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'generatorCode',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.generatorCode',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstGeneratorSet'
                    ,correspondingField: 'generatorCode'
                    ,fieldsBindingByEntityModalSelected: '{"generatorSetId":"id"}'
                        }
                },
                {
                key: 'shutdownTime',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.shutdownTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'restartTime',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.restartTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'shutdownReason',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.shutdownReason',
                sortable: true,
                disabled: false,
                form: {
                type: 'select'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: '机组本身原因' },
                        { value: '2', text: '四台电炉停炉引起煤气量不足' },
                        { value: '3', text: '限电' }
                    ]
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdGenertorSetDowntime.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdGenertorSetDowntime, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        